module.exports = __webpack_public_path__ + "static/img/php.2e2e7403.png";